import { useMemo } from 'react';
import { useObservation } from 'apps/sigma2-ui/src/state/observation';

// Obtain the selected IDs from the current user and observation.
export const useUserObservationOrgAndDbIds = (): {
  selectedOrganizationId: string | null;
  selectedDatabaseId: string | null;
  selectedDatabaseRevisionId: string | null;
} => {
  const { myObservation, selectedOrganizationId } = useObservation();

  return useMemo(() => {
    const selectedDatabaseId = myObservation?.type.databaseId || null;
    const selectedDatabaseRevisionId =
      myObservation?.type.databaseRevisionId || null;

    return {
      selectedOrganizationId,
      selectedDatabaseId,
      selectedDatabaseRevisionId,
    };
  }, [
    myObservation?.type.databaseId,
    myObservation?.type.databaseRevisionId,
    selectedOrganizationId,
  ]);
};
